import React from 'react';

function LoadingSpinner({ region }) {
  return (
    <div className="loading-container">
      <p className="loading-text">Loading layers for <span className="region-highlight">{region}</span>...</p>
      <div className="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
